import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  eclipseDriveStarIcon,
  eclipseDriveTrophyIcon,
  eclipseDriveAmbassadorLicenseIcon,
  eclipseDriveHandshakeIcon,
  eclipseDriveCalendarIcon,
  eclipseDriveBulbIcon,
  eclipseDriveEki2Icon,
} from 'assets/images';
import styles from './styles.module.scss';

const criteriaCards = [
  {
    icon: eclipseDriveStarIcon, alt: 'Top 10', textKey: 'top10', hasEki: true,
  },
  {
    icon: eclipseDriveTrophyIcon, alt: 'Winners', textKey: 'winners', hasEki: false,
  },
  {
    icon: eclipseDriveAmbassadorLicenseIcon, alt: 'Licenses', textKey: 'sellers', hasEki: false,
  },
];

const benefitCards = [
  {
    icon: eclipseDriveHandshakeIcon, alt: 'Management Access', iconClass: 'handshake_icon', textKey: 'management',
  },
  {
    icon: eclipseDriveBulbIcon, alt: 'VIP Events', iconClass: 'bulb_icon', textKey: 'projects',
  },
  {
    icon: eclipseDriveCalendarIcon, alt: 'Closed Projects', iconClass: 'calendar_icon', textKey: 'events',
  },
];

export const AmbassadorSection = () => {
  const { t } = useTranslation('eclipseDrive');

  return (
    <div className={styles.section}>
      <div className={styles.section_content}>
        <div className={styles.header}>
          <h2 className={styles.section_title}>{t('ambassador.title')}</h2>
          <p className={styles.section_subtitle}>
            {t('ambassador.subtitle')}
          </p>
        </div>
        
        <div className={styles.who_gets}>
          <h3 className={styles.subsection_title}>{t('ambassador.whoGetsTitle')}</h3>
          
          <div className={styles.criteria_cards}>
            {criteriaCards.map(({
              icon, alt, textKey, hasEki,
            }) => (
              <div
                key={textKey}
                className={styles.criteria_card}
              >
                {hasEki && (
                  <img
                    src={eclipseDriveEki2Icon}
                    alt="Eki mascot"
                    className={styles.eki2_icon}
                  />
                )}
                <img
                  src={icon}
                  alt={alt}
                  className={styles.card_icon}
                />
                <div className={styles.criteria_text}>
                  {t(`ambassador.whoGets.${textKey}`)}
                </div>
              </div>
            ))}
          </div>
        </div>
        
        <div className={styles.benefits}>
          <h3 className={styles.subsection_title}>{t('ambassador.benefitsTitle')}</h3>
          
          <div className={styles.benefit_cards}>
            {benefitCards.map(({
              icon, alt, iconClass, textKey,
            }) => (
              <div
                key={textKey}
                className={styles.benefit_card}
              >
                <img
                  src={icon}
                  alt={alt}
                  className={styles[iconClass]}
                />
                <div className={styles.benefit_text}>
                  {t(`ambassador.benefits.${textKey}`)}
                </div>
              </div>
            ))}
          </div>
        </div>
        
        <div className={styles.bottom_quote_wrapper}>
          <p className={styles.bottom_quote_top}>
            {t('ambassador.quoteTop')}
          </p>
          <p className={styles.bottom_quote_bottom}>
            {t('ambassador.quoteBottom')}
          </p>
        </div>
      </div>
    </div>
  );
};
